/*
 * Project: INFARMA Kodeks Przejrzystosci Public
 * File: currency.ts
 * File Created: Monday, 29th June 2020 11:07:59 pm
 * Author: Remek Kasprzak (remekkasprzak@gmail.com)
 * -----
 * Copyright 2020, Raz Dwa Projekt
 * This software is under proprietary license.
 */

import Vue from "vue";

const formatCurrency = (number: number) =>
  (number || 0).toLocaleString("pl-PL", { style: "currency", currency: "PLN" });

Vue.filter("formatCurrency", formatCurrency);

export default formatCurrency;
